// frontend/src/constants/frequencies.js
//
// Mirrors the backend's app/plan_tiers.py:
//   - FREQUENCY_LABELS for UI display
//   - PLAN_FREQUENCIES for plan-aware dropdown gating
//
// Keep in sync with the backend. The backend is source of truth at
// validation time; this file is only for rendering the dropdown.

export const FREQUENCY_LABELS = {
  daily: 'Daily',
  twice_daily: 'Twice daily',
  every_6_hours: 'Every 6 hours',
  every_2_hours: 'Every 2 hours',
  hourly: 'Hourly',
  every_15_min: 'Every 15 minutes',
};

// Ordered list (most-restrictive to most-frequent). Use this when
// rendering the dropdown so customers see options in a sensible order.
export const FREQUENCY_ORDER = [
  'daily',
  'twice_daily',
  'every_6_hours',
  'every_2_hours',
  'hourly',
  'every_15_min',
];

export const PLAN_FREQUENCIES = {
  trial:       ['daily'],
  solo:        ['daily'],
  crew:        ['daily', 'twice_daily', 'every_6_hours'],
  studio:      ['daily', 'twice_daily', 'every_6_hours', 'every_2_hours', 'hourly'],
  enterprise:  ['daily', 'twice_daily', 'every_6_hours', 'every_2_hours', 'hourly', 'every_15_min'],
  grandfather: ['daily', 'twice_daily', 'every_6_hours', 'every_2_hours', 'hourly', 'every_15_min'],
  custom:      ['daily', 'twice_daily', 'every_6_hours', 'every_2_hours', 'hourly', 'every_15_min'],
};

export function allowedFrequenciesFor(plan) {
  if (!plan) return ['daily'];
  return PLAN_FREQUENCIES[plan] || ['daily'];
}

export function frequencyLabel(token) {
  return FREQUENCY_LABELS[token] || token || 'Manual';
}

// Marketing copy: which plan unlocks each frequency. Used in upsell
// messaging when a customer hovers a locked option.
export const PLAN_FOR_FREQUENCY = {
  daily: 'Solo',
  twice_daily: 'Crew',
  every_6_hours: 'Crew',
  every_2_hours: 'Studio',
  hourly: 'Studio',
  every_15_min: 'Enterprise',
};